import Heading from '@tiptap/extension-heading';
import { mergeAttributes } from '@tiptap/core';

/**
 * Heading extension that supports a `class` attribute so AI diff
 * can apply .ai-added / .ai-modified to headings.
 */
export const HeadingWithClass = Heading.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      class: {
        default: null,
        parseHTML: (element) => element.getAttribute('class') || null,
        renderHTML: (attrs) => (attrs.class ? { class: attrs.class } : {}),
      },
    };
  },

  parseHTML() {
    return this.options.levels.map((level) => ({
      tag: `h${level}`,
      getAttrs: (node) => {
        const el = typeof node === 'string' ? null : node;
        const classVal = el?.getAttribute?.('class') || null;
        return { level, ...(classVal ? { class: classVal } : {}) };
      },
    }));
  },

  renderHTML({ node, HTMLAttributes }) {
    const level = this.options.levels.includes(node.attrs.level)
      ? node.attrs.level
      : this.options.levels[0];
    return [
      `h${level}`,
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        ...(node.attrs.class ? { class: node.attrs.class } : {}),
      }),
      0,
    ];
  },
}).configure({ levels: [1, 2, 3, 4, 5, 6] });
